import {engineContext} from './context.js';

(function(g){'use strict';
const VERSION='0.1.0-alpha';

function requireEngine(obj,name,method){
  if(!obj||typeof obj[method]!=='function') throw Error(name+'_REQUIRED');
  return obj;
}
function worstState(states){
  if(states.includes('BLOCK')) return 'BLOCK';
  if(states.includes('REVIEW')) return 'REVIEW';
  if(states.includes('MISSING')) return 'REVIEW';
  return 'READY';
}

function create(opts={}){
  const providerBridge=requireEngine(opts.providerBridge||g.ZooInvestProviderToResearchRuntimeBridge,'PROVIDER_BRIDGE','create');
  const secSnapshot=requireEngine(opts.secSnapshot||g.ZooInvestSECCanonicalFinancialSnapshot,'SEC_SNAPSHOT','buildSnapshot');
  const healthBridge=requireEngine(opts.healthBridge||g.ZooInvestSECFinancialHealthInputBridge,'HEALTH_BRIDGE','toFinancialHealthBridge');
  const historyEngine=requireEngine(opts.historyEngine||g.ZooInvestSECFinancialHistoryEngine,'HISTORY_ENGINE','build');
  const trajectoryBridge=requireEngine(opts.trajectoryBridge||g.ZooInvestSECGrowthTrajectoryInputBridge,'TRAJECTORY_BRIDGE','build');

  const providerRuntime=providerBridge.create(opts.providerRuntimeOptions||{});

  if(opts.secAdapter) providerRuntime.registerAdapter('sec',opts.secAdapter);
  if(opts.marketAdapter) providerRuntime.registerAdapter('market',opts.marketAdapter);

  async function buildCompanyPackage(req={}){
    const symbol=String(req.symbol||'').trim().toUpperCase();
    if(!symbol) throw Error('SYMBOL_REQUIRED');

    const providerData=await providerRuntime.loadCompanyResearchData({
      symbol,
      cik:req.cik,
      outputsize:req.outputsize||'compact'
    });

    let canonical=null,financialHealth=null,history=null,trajectory=null;
    const issues=[];

    if(providerData.researchInput.fundamentals){
      try{
        canonical=secSnapshot.buildSnapshot(providerData.researchInput.fundamentals);
        financialHealth=healthBridge.toFinancialHealthBridge(canonical);
        history=historyEngine.build(providerData.researchInput.fundamentals,{maxYears:req.maxYears||10});
        trajectory=trajectoryBridge.build(history);
      }catch(e){
        issues.push({stage:'SEC_NORMALIZATION',severity:'REVIEW',message:String(e.message||e)});
      }
    }else{
      issues.push({stage:'SEC_NORMALIZATION',severity:'REVIEW',message:'FUNDAMENTALS_MISSING'});
    }

    const market=providerData.researchInput.marketDaily||null;
    const marketMeta=providerData.researchInput.marketMeta||null;
    if(!market) issues.push({stage:'MARKET_DATA',severity:'REVIEW',message:'MARKET_DAILY_MISSING'});

    const stageStates=[
      providerData.status,
      canonical?'READY':'REVIEW',
      financialHealth?(financialHealth.state==='MISSING'?'REVIEW':'READY'):'REVIEW',
      history?'READY':'REVIEW',
      trajectory?'READY':'REVIEW',
      market?'READY':'REVIEW'
    ];

    return Object.freeze({
      version:VERSION,
      symbol,
      status:worstState(stageStates),
      generatedAt:new Date().toISOString(),
      sourceState:Object.freeze({
        providerStatus:providerData.status,
        fundamentals:providerData.researchInput.fundamentalsMeta,
        market:marketMeta
      }),
      companyResearch:Object.freeze({
        canonicalFinancials:canonical,
        financialHealth,
        financialHistory:history,
        growthTrajectory:trajectory,
        marketDaily:market
      }),
      providerResults:providerData.providerResults,
      issues:Object.freeze(issues),
      guards:Object.freeze({
        noUniversalScore:true,
        noTradeSignal:true,
        noCapitalPermission:true,
        uncalibratedScoresRemainNull:true
      })
    });
  }

  return Object.freeze({VERSION,buildCompanyPackage,registerAdapter:providerRuntime.registerAdapter});
}

async function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});

  const providerBridge={
    create:()=>({
      registerAdapter(){return true;},
      async loadCompanyResearchData(req){
        return {
          status:'READY',
          researchInput:{
            fundamentals:{
              symbol:req.symbol,entityName:'AAA Corp',cik:123,
              facts:{
                Revenues:[
                  {value:100,fy:2024,start:'2024-01-01',end:'2024-12-31',filed:'2025-02-01',form:'10-K',fp:'FY',unit:'USD'},
                  {value:120,fy:2025,start:'2025-01-01',end:'2025-12-31',filed:'2026-02-01',form:'10-K',fp:'FY',unit:'USD'}
                ],
                NetIncomeLoss:[
                  {value:10,fy:2024,start:'2024-01-01',end:'2024-12-31',filed:'2025-02-01',form:'10-K',fp:'FY',unit:'USD'},
                  {value:15,fy:2025,start:'2025-01-01',end:'2025-12-31',filed:'2026-02-01',form:'10-K',fp:'FY',unit:'USD'}
                ]
              }
            },
            fundamentalsMeta:{state:'VERIFIED',asOf:'2026-02-01',provenance:{provider:'SEC'}},
            marketDaily:{rows:[{date:'2026-08-29',close:123.45}]},
            marketMeta:{state:'VERIFIED',asOf:'2026-08-29',provenance:{provider:'Alpha Vantage'}}
          },
          providerResults:[{status:'READY'},{status:'READY'}]
        };
      }
    })
  };

  const secSnapshot={
    buildSnapshot:cf=>({
      symbol:cf.symbol,entityName:cf.entityName,
      metrics:{
        revenue:{value:120,status:'VERIFIED'},
        netIncome:{value:15,status:'VERIFIED'}
      },derived:{totalDebt:{value:null}}
    })
  };
  const healthBridge={
    toFinancialHealthBridge:s=>({symbol:s.symbol,state:'REVIEW_ONLY',autoScore:false,calibrated:false})
  };
  const historyEngine={
    build:(cf,o)=>({symbol:cf.symbol,maxYears:o.maxYears,metrics:{revenue:{points:[{fy:2024,value:100},{fy:2025,value:120}],cagrPct:20}},derived:{freeCashFlow:{points:[],cagrPct:null}}})
  };
  const trajectoryBridge={
    build:h=>({symbol:h.symbol,autoScore:false,calibrated:false,factual:{revenueCagrPct:20}})
  };

  const api=create({providerBridge,secSnapshot,healthBridge,historyEngine,trajectoryBridge});
  const p=await api.buildCompanyPackage({symbol:'aaa',cik:'123',maxYears:10});
  ok('symbol normalized',p.symbol==='AAA');
  ok('package ready',p.status==='READY');
  ok('canonical financials included',p.companyResearch.canonicalFinancials.entityName==='AAA Corp');
  ok('financial health included',p.companyResearch.financialHealth.autoScore===false);
  ok('history included',p.companyResearch.financialHistory.maxYears===10);
  ok('trajectory included',p.companyResearch.growthTrajectory.factual.revenueCagrPct===20);
  ok('market included',p.companyResearch.marketDaily.rows[0].close===123.45);
  ok('fundamental source state preserved',p.sourceState.fundamentals.state==='VERIFIED');
  ok('market source state preserved',p.sourceState.market.state==='VERIFIED');
  ok('provider results retained',p.providerResults.length===2);
  ok('no issues in complete package',p.issues.length===0);
  ok('guard universal score active',p.guards.noUniversalScore===true);
  ok('guard trade signal active',p.guards.noTradeSignal===true);
  ok('guard capital permission active',p.guards.noCapitalPermission===true);
  ok('uncalibrated score guard active',p.guards.uncalibratedScoresRemainNull===true);

  const missingProviderBridge={
    create:()=>({
      registerAdapter(){},
      async loadCompanyResearchData(){
        return {status:'REVIEW',researchInput:{
          fundamentals:null,fundamentalsMeta:null,marketDaily:null,marketMeta:null
        },providerResults:[]};
      }
    })
  };
  const m=create({providerBridge:missingProviderBridge,secSnapshot,healthBridge,historyEngine,trajectoryBridge});
  const mp=await m.buildCompanyPackage({symbol:'BBB'});
  ok('missing providers force review',mp.status==='REVIEW');
  ok('missing fundamentals explicit issue',mp.issues.some(x=>x.message==='FUNDAMENTALS_MISSING'));
  ok('missing market explicit issue',mp.issues.some(x=>x.message==='MARKET_DAILY_MISSING'));
  ok('missing canonical remains null',mp.companyResearch.canonicalFinancials===null);
  ok('missing history remains null',mp.companyResearch.financialHistory===null);

  let se=false;try{await api.buildCompanyPackage({symbol:''})}catch(e){se=e.message==='SYMBOL_REQUIRED'}
  ok('symbol required',se);

  let pe=false;try{create({providerBridge:{}})}catch(e){pe=e.message==='PROVIDER_BRIDGE_REQUIRED'}
  ok('provider bridge required',pe);

  const failSnapshot={buildSnapshot:()=>{throw Error('NORMALIZE_FAIL')}};
  const f=create({providerBridge,secSnapshot:failSnapshot,healthBridge,historyEngine,trajectoryBridge});
  const fp=await f.buildCompanyPackage({symbol:'CCC'});
  ok('normalization failure contained',fp.status==='REVIEW');
  ok('normalization issue recorded',fp.issues.some(x=>x.message==='NORMALIZE_FAIL'));

  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

g.ZooInvestCompanyResearchDataPackage=Object.freeze({VERSION,create,selfTest});
})(engineContext);